/**
 * Small helpers for "Bring in your brand" on the wizard's Page step.
 */

/**
 * An image address a canvas can read pixels from. Reading a logo's colours
 * draws it on a canvas, and a cross-origin image without CORS headers taints
 * the canvas, so the read fails and the page never got the logo's colours.
 * Same-origin, data: and blob: addresses are safe as they are; anything else
 * goes through our image proxy, which re-serves it with CORS.
 */
export function canvasSafe(url: string): string {
  if (!/^https?:\/\//i.test(url)) return url;
  if (typeof window !== 'undefined') {
    try {
      if (new URL(url).origin === window.location.origin) return url;
    } catch {
      return url;
    }
  }
  return `/api/proxy-image?url=${encodeURIComponent(url)}`;
}

/** What an import brought in, for the row's status line. Says so when no logo was found. */
export function importSummary({ logo, colours, font }: { logo: boolean; colours: number; font: string | null }): string {
  const parts = [logo ? 'your logo' : null, `${colours} ${colours === 1 ? 'colour' : 'colours'}`, font].filter(Boolean);
  const said = `Imported ${parts.join(', ')}`;
  return logo ? said : `${said}. No logo found, upload it above`;
}
